import { Navigate } from "react-router-dom"

const AuthenticatedLogin = ({ isAuthenticated, loading, children }) => {
    if (loading) return <div>Cargando...</div>;
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    return children;
}

export default AuthenticatedLogin;